/* eslint-disable jsx-a11y/anchor-has-content */
import React, { Component, Fragment } from 'react'
import ReactDOM from 'react-dom'

export default class Footer extends Component {
  render() {
    return (
      <Fragment>
        <a href="/" className="site-branding footer-logo" />
      </Fragment>
    )
  }
}

ReactDOM.render(<Footer />, document.querySelector('#footer'))
